export function StepsLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="md:mt-24 lg:mx-32">
      <div className="flex items-center p-5 space-x-2 lg:p-0 lg:-ml-0.5">
        <img
          width="40"
          height="40"
          src="/assets/logo-segments.png"
          alt="logo"
          className="w-6 h-6 lg:h-10 lg:w-10"
        />
        <p className="text-base lg:p-0 lg:text-2xl tracking-segments-logo text-segments-dark">
          Segments
        </p>
      </div>
      <div className="mx-auto">{children}</div>
    </div>
  );
}
